// Utility usate in più moduli e nelle ready() block di main.js.
/** FUNCTIONS **/

function stopScroll() {
    $('html, body').css({
        overflow: 'hidden', height: '100%'
    });
}

function restoreScroll() {
    $('html, body').css({
        overflow: 'auto', height: 'auto'
    });
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}

function mobileNav() {
    const content = $('.hero-menu--to-mobile-submenu').html();
    $('.mobile-submenu').html(content);
    $('.hero-menu--to-mobile-submenu').empty();
}

function addFileUploader() {
    const temp = '<div class="row allegato-item m-b-sm">\n' + '<div class="col-12 input-group">\n' + '<input type="file" name="allegato[]" id="allegato" class="form-control" multiple>\n' + '<a href="javascript:;" class="remove-allegato" onclick="removeFileUploader(this)"><i class="bi bi-dash-lg fa-lg"></i></a>\n' + '</div>\n' + '</div>';
    $('.allegato-wrapper').append(temp);
    $('.remove-allegato').removeClass('d-none');
}

function removeFileUploader(el) {
    const row = el.closest('.allegato-item');
    row.remove();
    if ($('.allegato-item').length == 1) {
        $('.remove-allegato').addClass('d-none');
    }
}


function printErrorMessages(msg) {
    Object.keys(msg).forEach(function (key) {
        $('.form-error[data-validate-for="' + key + '"]').text(msg[key]);
    });
}


function is_mobile() {
    return (/webOS|iPhone|Opera Mini/i.test(navigator.userAgent));
}


function isOnScreenMobile(elem) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
        return null;
    }
    const $window = jQuery(window);
    const viewport_top = $window.scrollTop();
    const viewport_height = $window.height();
    const viewport_bottom = viewport_top + viewport_height;
    const $elem = jQuery(elem);
    const top = $elem.offset().top;
    const height = $elem.height();
    const bottom = top + height;

    return (top >= viewport_top && top < viewport_bottom) || (bottom > viewport_top && bottom <= viewport_bottom) || (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom);
}

window.submitSupportForm = function (form) {
    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        processData: false,
        contentType: false,
        url: window.location.protocol + "//" + window.location.host + "/submit-ticket",
        data: new FormData(form),
        success: function (data) {
            console.log(data)
            if ($.isEmptyObject(data.error)) {
                $('.support-alert-success').removeClass('d-none');
                $('#supportFormBtn').prop('disabled', true);
            } else {
                printErrorMessages(data.error);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function scrollTo(anchor) {
    const to = $(anchor)

    if (to.length === 0) {
        return null;
    }

    $("html, body").animate({scrollTop: to.offset().top - 120}, 500);
}


export {
    scrollTo,
    stopScroll,
    restoreScroll,
    isInViewport,
    mobileNav,
    addFileUploader,
    removeFileUploader,
    printErrorMessages,
    is_mobile,
    isOnScreenMobile,
};
